import { useState } from "react";

export const useHandler = (): [
	{ loading: boolean; error: string; success: string },
	(
		type?: "loading" | "error" | "success" | null,
		state?: string | boolean | null
	) => void
] => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string>("");
	const [success, setSuccess] = useState<string>("");

	const handling = (
		type?: "loading" | "error" | "success" | null,
		state?: string | boolean | null
	): void => {
		switch (type) {
			case "loading":
				setLoading(state as boolean);
				break;
			case "error":
				if (state === "Request failed with status code 500")
					setError(`${state} (server down)`);
				setError(state as string);
				break;
			case "success":
				setSuccess(state as string);
				break;
		}
	};

	return [{ loading, error, success }, handling];
};

// type State = "loading" | "error" | "success";
// type Handler = {
//   [key in State]?: string | boolean;
// };
